import React from 'react'

import DatatableLimit from './DatatableLimit'
import DatatablePagination from './DatatablePagination'

type Props = {
	showPagination: boolean
}

const DatatableFooter = ({ showPagination }: Props) => {
	return (
		<div className="flex items-center justify-center p-4 border-t border-gray-100">
			<div className="mx-auto">{showPagination && <DatatablePagination />}</div>
			<DatatableLimit />
		</div>
	)
}

export default DatatableFooter
